module.exports = __webpack_public_path__ + "assets/overlaynone.8a13db7b.svg";